export type Cell = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export interface Piece {
  shape: number[][];
  color: Cell;
  x: number;
  y: number;
}

export interface BlockByBlockGame {
  board: Cell[][];
  current: Piece | null;
  next: Piece | null;
  score: number;
  level: number;
  lines: number;
  gameOver: boolean;
  dropTimer: number;
  dropInterval: number;
}

export const COLS = 10;
export const ROWS = 20;
export const CELL = 28;

export const PIECES: Array<{ shape: number[][]; color: Cell }> = [
  { shape: [[1, 1, 1, 1]], color: 1 },
  { shape: [[1, 1], [1, 1]], color: 2 },
  { shape: [[0, 1, 0], [1, 1, 1]], color: 3 },
  { shape: [[1, 0, 0], [1, 1, 1]], color: 4 },
  { shape: [[0, 0, 1], [1, 1, 1]], color: 5 },
  { shape: [[0, 1, 1], [1, 1, 0]], color: 6 },
  { shape: [[1, 1, 0], [0, 1, 1]], color: 7 },
];

export const COLORS: Record<number, string> = {
  0: "transparent",
  1: "#00f0f0",
  2: "#f0f000",
  3: "#a000f0",
  4: "#0000f0",
  5: "#f0a000",
  6: "#00f000",
  7: "#f00000",
};
